<template>
  <v-tooltip right content-class="portal-tooltip" v-if="slaColor">
    <template v-slot:activator="{ on }">
      <v-icon :color="slaColor" left v-on="on">notifications_active</v-icon>
    </template>
    <span>{{ slaText }}</span>
  </v-tooltip>
</template>

<script>
import dayjs from "dayjs";

export default {
  props: {
    slaDetail: {
      type: Object,
      required: false,
      default: () => {}
    }
  },
  computed: {
    entityState() {
      if (this.slaDetail?.currentEntityState) {
        return this.slaDetail.currentEntityState;
      }
      return null;
    },
    expirationDate() {
      if (this.slaDetail?.expirationDate) {
        return this.slaDetail.expirationDate;
      }
      return null;
    },
    slaType() {
      if (this.slaDetail?.slaEnum) {
        return this.slaDetail.slaEnum;
      }
      return null;
    },
    slaState() {
      if (this.slaDetail?.slaStateEnum) {
        return this.slaDetail.slaStateEnum;
      }
      return null;
    },
    timeToExpirationInDays() {
      if (this.slaDetail?.timeToExpirationInDays) {
        return this.slaDetail.timeToExpirationInDays;
      }
      return 0;
    },
    slaColor() {
      let states = ["SENTBACK"];
      if (states.includes(this.entityState) && this.slaState === "OK") {
        return "success";
      }
      if (states.includes(this.entityState) && this.slaState === "KO") {
        return "error";
      }
      if (states.includes(this.entityState) && this.slaState === "WARNING") {
        return "warning";
      }
      return "";
    },
    slaText() {
      let expDate = dayjs(this.expirationDate).format("DD/MM/YYYY");
      let days = Number(
        this.timeToExpirationInDays.toString().replace("-", "")
      );
      let pos = this.$t("bills.slaTooltip.positive");
      let zero = this.$t("bills.slaTooltip.zero");
      let neg = this.$t("bills.slaTooltip.negative");
      let daysLabel =
        days === 1
          ? this.$t("bills.slaTooltip.day")
          : this.$t("bills.slaTooltip.days");
      if (this.timeToExpirationInDays > 0) {
        return `${pos} ${expDate}`;
      }
      if (this.timeToExpirationInDays === 0) {
        return `${zero}`;
      }
      if (this.timeToExpirationInDays < 0) {
        return `${neg} ${days} ${daysLabel}`;
      }
      return "";
    }
  }
};
</script>
